import React, {useEffect, useState} from "react";
import Questions from '../../questionnaires/config';
import { Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/fontawesome-free-solid';
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import { faChevronRight } from '@fortawesome/fontawesome-free-solid'
import { faChevronLeft } from '@fortawesome/fontawesome-free-solid'


function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div onClick={onClick} style={{...style}} className={"chevron-button-right " + className} role="button"><FontAwesomeIcon size={"lg"} icon={faChevronRight} /></div>

    );
}
  
function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div onClick={onClick} style={{...style}} className={"chevron-button-left " + className} role="button"><FontAwesomeIcon size={"lg"} icon={faChevronLeft} /></div>
    );
}

export default function Questionnaire(props) {

    const [answerSelected, setAnswerSelected] = useState(false);
    const [answersLength, setAnswersLength] = useState(0);
    const { t } = useTranslation('common');

    let settings = {
        speed: 500,
        slidesToScroll: 1,
        slidesToShow: 3,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        variableWidth: false,
        variableHeight: false,
        centerPadding: 0,
        centerMode: false,
        infinite: false,
        initialSlide: 0,
        arrows: true,
        responsive: [
            {
                breakpoint: 768,
                    settings: {
                    dots: true,
                },
            },
            {
                breakpoint: 412,
                settings: {
                    slidesToShow: 2,
                    infinite: true,
                    arrows: false,
                    dots: true
                }
            }
        ]
    };

    useEffect(() => {
        let answerAvalible = [];

        if(props.currentQuestion > 1) {
            answerAvalible = Questions.questionnaire.questions[props.currentQuestion].answers.filter(current => props.nextPossibleAnswers.includes(current.text.toLowerCase()));
        }else {
            answerAvalible = Questions.questionnaire.questions[props.currentQuestion].answers;
        }

        setAnswersLength(answerAvalible.length);
    }, [props.currentQuestion, props.nextPossibleAnswers]);

    useEffect(() => {
        if(props.answers.hasOwnProperty(props.currentQuestion)) {
                setAnswerSelected(true);
        }else {
            setAnswerSelected(false);
        }

    }, [props.answers, props.currentQuestion, props.answerAvalible])

    function handleAnswer(answer) {

        //Add id and answer to an object, and save it to state
        if(props.answers.hasOwnProperty(props.currentQuestion)) {
            props.setAnswers(prevState => {
                let temp = Object.assign({}, prevState);
                temp[props.currentQuestion] = answer;
                return { ...temp };
            })

        }else {
            let answerObj = {};
            answerObj[props.currentQuestion] = answer;
            props.setAnswers({...props.answers, ...answerObj});
        }
    }

    //Next question
    function next() {
        if(props.currentQuestion < Object.keys(Questions.questionnaire.questions).length) {
            props.setCurrentQuestion(props.currentQuestion + 1);
        }

        if(props.questionnaireFinished) {
            props.setDisplayResults(true);
        }
    }

    //Previous question
    function previous() {
        if(props.currentQuestion > 1) {
            props.setCurrentQuestion(props.currentQuestion - 1);
        }
    }

    //Check if answer is active or not
    function checkAnswer(answer) {
        return props.answers.hasOwnProperty(props.currentQuestion) ? props.answers[props.currentQuestion] === answer ? true : false : false;
    }

    function getMultipleAnswer(ans) {
        let answer = {...ans};

        if(props.currentQuestion === 4) {
            if(props.answers[3] === t("Deep Tan") || props.answers[3] === t("Rich")) {
                answer.picture = ans.picture.dark
                answer.details = ans.details.dark
            }else {
                answer.picture = ans.picture.light
                answer.details = ans.details.light
            };
            return answer;
        }
        else {
            return answer;
        }
    }

    function setupUniqueAnswers() {
        let current = Questions.questionnaire.questions[props.currentQuestion]
        let answerAvalible = [];

        if(props.currentQuestion > 1) {
            answerAvalible = Questions.questionnaire.questions[props.currentQuestion].answers.filter(current => props.nextPossibleAnswers.includes(current.text.toLowerCase()));
        }else {
            answerAvalible = Questions.questionnaire.questions[props.currentQuestion].answers;
        }
        return answerAvalible.map((ans, i) => {
            let imgUrl = "";
            let answer = ans.multiple ? getMultipleAnswer(ans) : ans;

            if(props.currentQuestion === 3) {
                let type = props.answers[1] === "Full Coverage" ? "full_coverage" : props.answers[1] === "Buildable Coverage" ? "medium_buildable_coverage" : "light_coverage";
                imgUrl = answer.picture.url.replace("{type}", type)
            }else if(props.currentQuestion === 5){
                imgUrl = answer.picture.url;
                props.filterProductsForQuestion(5).forEach(product => {
                    if(product.answer_5.toLowerCase() === ans.text.toLowerCase()) {
                        imgUrl = "/question_5/" + product.product_image;
                    }
                });
            }
            else {
                imgUrl = answer.picture.url
            }
            
            return(
                <div>
                    <Col key={`answer_${i}`} align="center"
                        className="answerCol"
                        onClick={() => handleAnswer(answer.text)}
                    >
                        <div className={ !checkAnswer(answer.text) ? "select-circle" : "selected"}>
                            <FontAwesomeIcon icon={faCheck} />
                        </div>
                        <div className="image-wrapper">
                            <img key={answer.text}
                                className={answer.picture.height !== "" ? "question-props.answers-answer" : ""}
                                alt={answer.text}
                                src={process.env.PUBLIC_URL + '/images' + imgUrl}>
                            </img>
                            <div className="question-answer-text question-answer-text-on-image" style={{display:"none"}}>{t(answer.text)}</div>
                        </div>
                        <div className="product-details" style={current.textStyle}>
                            <p className="product-details-name"> {t(answer.text)} {answer.code ? <span className="question-answer-code">{props.allProductTypes[answer.picture.url.slice(12, 25)].code}</span> : null}</p>
                            {answer.code ? <p className="product-details-desc" style={{}}>{t(props.allProductTypes[answer.picture.url.slice(12, 25)].detail)}</p> : null }
                        </div>
                        {answer.details.length ?
                        <div className="question-answer-details">
                            {answer.details.map(detail => {
                                return(
                                    <li style={{paddingBottom:"5px"}}>{t(detail)}</li>
                                );
                            })}
                        </div> : null}
                    </Col>
                </div>
            );
        })
    }

    return(
        <div className="questionnarie">
            <h2 className="question-header"><span>{props.currentQuestion}.</span> {t(Questions.questionnaire.questions[props.currentQuestion].question)}</h2>
            <p key={`step-${props.currentQuestion}`} className="steps">{t("Step " + props.currentQuestion + " of 6")}</p>

            <Row className={"question-props.answers questions-grid justify-content-center question-answers-" + props.currentQuestion}>
                <div className={"question-carosuel item-" + answersLength}>
                    <Slider {...settings} slidesToShow={answersLength < 3 ? answersLength : 3} infinite={false}>
                        {setupUniqueAnswers()}
                    </Slider>
                </div>
            </Row>
            <Row className="questionnarie-button-group">
                <Col key={`prev-${props.currentQuestion}`} className="prev">
                    {props.currentQuestion > 1 && <Button id="prev" onClick={previous}>{t("Back")}</Button>}
                </Col>
                <Col key={`next-${props.currentQuestion}`} className="next">
                    <Button id="next" disabled={!answerSelected ||
                        !Questions.questionnaire.questions[props.currentQuestion].answers
                            .filter(current => props.nextPossibleAnswers.includes(current.text.toLowerCase()))
                            .map(x => x.text).includes(props.answers[props.currentQuestion])}
                        onClick={() => next()}>{props.questionnaireFinished ? t('Results') : answerSelected ? t('Next Step') : t('Select Answer')}
                    </Button>
                </Col>
            </Row>
        </div>
    );
}
